// extracted by mini-css-extract-plugin
module.exports = {"box":"aside-module--box--2e3xL"};